import { render, staticRenderFns } from "./resCheck.vue?vue&type=template&id=6469211a&scoped=true&"
import script from "./resCheck.vue?vue&type=script&lang=js&"
export * from "./resCheck.vue?vue&type=script&lang=js&"
import style0 from "./resCheck.vue?vue&type=style&index=0&id=6469211a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6469211a",
  null
  
)

export default component.exports